<script setup lang="ts">
import { computed, useAttrs } from 'vue'
import { Icon } from '@iconify/vue'

const props = defineProps<{
  icon?: string
  size?: string
}>()

const attrs = useAttrs()

const bindAttrs = computed(() => ({
  class: (attrs.class as string) || '',
  style: (attrs.style as string) || '',
}))

const iconSize = computed(() => {
  return props.size || '18'
})
</script>

<template>
  <Icon :icon="props.icon || ''" :width="iconSize" :height="iconSize" v-bind="bindAttrs" />
</template>
